import { createContext, useContext, useState, useEffect } from "react";
import { login as apiLogin, logout as apiLogout, checkSession } from "../utils/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [authenticated, setAuthenticated] = useState(false);
  const [checkingSession, setCheckingSession] = useState(true);

  // On mount, ask the server whether the existing httpOnly cookie (if any)
  // is still valid — this is what lets a page refresh on /admin/payouts
  // stay logged in instead of bouncing to /login.
  useEffect(() => {
    checkSession()
      .then(() => setAuthenticated(true))
      .catch(() => setAuthenticated(false))
      .finally(() => setCheckingSession(false));
  }, []);

  async function login(password) {
    await apiLogin(password); // throws on failure, caller handles the message
    setAuthenticated(true);
  }

  async function logout() {
    await apiLogout(); // hits /logout, server clears the cookie
    setAuthenticated(false);
  }

  return (
    <AuthContext.Provider value={{ authenticated, checkingSession, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}